var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0c4adb93ed27fb8b8d787a58b0fa9036.js').default;
var scope_1 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0efbc5f3954d93f338e3c00338121d48.js').default;
var scope_2 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    